import React,{useState} from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./SliderSlide.css";

const sliderList = [
  {
    title: "100 percent syllabus coverage",
    imagePath: "./100Percent.jpg",
    description:
      "Master the UPSC CSE syllabus with our exclusive resources, ensuring complete preparation.",
  },
  {
    title: "360° Notes",
    imagePath: "./360deg.jpg",
    description:
      "Get complete Prelims and Mains coverage with examples and updated stats.",
  },
  {
    title: "NCERT Simplified",
    imagePath: "./FreeResources1.jpg",
    description:
      "Grasp fundamentals effortlessly with clear, exam-focused explanations that accelerate learning and save time.",
  },
  {
    title: "Highlight tool",
    imagePath: "./Highlight.jpg",
    description:
      "Mark key insights and revise efficiently with our intuitive highlighter tool.",
  },
  {
    title: "Comment tool",
    imagePath: "./Comment.jpg",
    description:
      "Add insights and clarifications on the go with our advanced commenting tool.",
  },
  {
    title: "Schedule Revisions",
    imagePath: "./RevisionScheduler.jpg",
    description:
      "Never miss a revision—set reminders and stay on track effortlessly.",
  },
  {
    title: "Powerful Search",
    imagePath: "./Search.jpg",
    description:
      "Find any topic instantly, saving time and streamlining study sessions.",
  },
  {
    title: "Craft Notes",
    imagePath: "./RevisionNotes.jpg",
    description: "Jot down key points in your words for seamless revision.",
  },
  {
    title: "Break Reminders",
    imagePath: "./Pomodoro.jpg",
    description:
      "Stay refreshed with break reminders that boost focus and retention.",
  },
  {
    title: "Syllabus-Aligned Organization",
    imagePath: "./StickToSyllabus.jpg",
    description:
      "Study efficiently with notes structured as per the official syllabus.",
  },
  {
    title: "Interactive Image Viewer",
    imagePath: "./ImageViewer.jpg",
    description:
      "Zoom into diagrams and illustrations for better visual understanding.",
  },
  {
    title: "Practice Mode",
    imagePath: "./PraticeMcqs.jpg",
    description:
      "Topic-wise UPSC MCQs with instant feedback. Learn, revise, and retry at your pace. Track accuracy and progress.",
  },
  {
    title: "Exam Mode",
    imagePath: "./ExamMcqs.jpg",
    description:
      "Real UPSC Prelims simulation. Timed tests, negative marking, performance stats. Build speed and confidence.",
  },
  {
    title: "Smart AI summerization",
    imagePath: "./AISummary.jpg",
    description:
      "Read less, understand more. Smart AI summaries in seconds.",
  },
  {
    title: "Revise smarter",
    imagePath: "./AIactiverecall.jpg",
    description:
      "Revise effectively with intelligent AI-crafted recall questions",
  }
];

function ImageModal({ img, onClose }) {
  if (!img) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center  z-[9999]"
      onClick={onClose}
    >
      <img
        src={img}
        className="max-w-[90%] max-h-[90%] rounded-xl shadow-2xl"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking image
        alt="Expanded"
      />
    </div>
  );
}

function SliderSlide({ imagePath, title, description, onImageClick }) {
   return (
    <div className="bg-white rounded-xl shadow-lg h-full border border-black 
      hover:shadow-[6px_6px_0px_black] hover:translate-y-[-5px] 
      transition-all duration-300 ease-in-out">

      <div
        className="h-48 flex justify-center items-center rounded-xl bg-[--var(--bgmain2)] overflow-hidden cursor-pointer"
        onClick={() => onImageClick(imagePath)}
      >
        <img
          src={imagePath}
          alt={title}
          className="max-w-full max-h-full object-contain"
        />
      </div>

      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 line-clamp-3">{description}</p>
      </div>
    </div>
  );
}
export default function ShowcaseSlider() {
  const [modalImage, setModalImage] = useState(null);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1536 },
      items: 4,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1536, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  return (
    <div className="py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-[var(--textmain1)]">
            Everything you need for UPSC CSE preparation
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Comprehensive resources to help you succeed
          </p>
        </div>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          pauseOnHover
          customTransition="transform 500ms ease-in-out"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {sliderList.map((slide, index) => (
            <div className="px-4" key={index}>
              <SliderSlide
                title={slide.title}
                imagePath={slide.imagePath}
                description={slide.description}
                onImageClick={(img) => setModalImage(img)}
              />
            </div>
          ))}
        </Carousel>
        <ImageModal img={modalImage} onClose={() => setModalImage(null)} />
      </div>
    </div>
  );
}
